import { getFaro } from '../faro';
import type { Faro } from '@grafana/faro-web-sdk';

import type { MetricsAdapter } from '../Metrics';
import type { ClientEnvironment } from 'bc-model';
import { faroAdapterFactory } from '../faro/config';

const faroAdapter = (env: ClientEnvironment): MetricsAdapter => {
  const faro: Faro | null = getFaro(env);

  return faroAdapterFactory(faro);
};

export const TESTING_INTERNAL = { faroAdapter };
export default faroAdapter;
